export const submitForm = async (formData) => {
  const url = `${process.env.REACT_APP_CMS_BASE_URL}/enquiry-forms`;
  // const url = "https://426c4zvf6uu7b6mb5ecm7jkgte0stflu.lambda-url.ap-southeast-1.on.aws/";
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({ data: formData }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              reject(errorData?.error?.message);
            });
          }
        })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject("System error: ", error);
    }
  });
};
